// extracted by mini-css-extract-plugin
export default {"innerCard":"DisplayController_innerCard__ULzIL","button":"DisplayController_button__8ZEYt"};